var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 12L23.5608 2.56137C24.1467 1.97541 24.1467 1.02538 23.5608 0.43947C22.9748 -0.14649 22.0248 -0.14649 21.4389 0.43947L12.0002 9.87905L2.56161 0.43947C1.97565 -0.14649 1.02563 -0.14649 0.439714 0.43947C-0.146199 1.02543 -0.146246 1.97545 0.439714 2.56137L9.8793 12L0.439714 21.4386C-0.146246 22.0246 -0.146246 22.9746 0.439714 23.5605C1.02567 24.1464 1.9757 24.1465 2.56161 23.5605L12.0002 14.1209L21.4388 23.5605C22.0248 24.1465 22.9748 24.1465 23.5607 23.5605C24.1467 22.9745 24.1467 22.0245 23.5607 21.4386L14.1211 12Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.a682ebe919125e4a6f86aa4871490654.svg";
export { ForwardRef as ReactComponent };